"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.seasonOverlapsDateRange = exports.getSeasonDates = exports.parseSeason = exports.getUpcomingSeasons = exports.getSeason = exports.isSummerMonth = exports.isSeasonType = exports.WINTER_START_MONTH = exports.SUMMER_START_MONTH = void 0;
exports.SUMMER_START_MONTH = 4;
exports.WINTER_START_MONTH = 10;
/** Type-guard for {@link SeasonType} */
const isSeasonType = (x) => x === 'summer' || x === 'winter';
exports.isSeasonType = isSeasonType;
/**
 * Test if the passed **zero indexed** month is in the summer season.
 *
 * @param month zero indexed month number in range 0..11;
 * @returns true if `month` is in the summer season, or false if the month is
 * 	in the winter season.
 * @throws if `month` is <0 or >11.
 */
const isSummerMonth = (month) => {
    if (month < 0 || month > 11) {
        throw new RangeError('Month must be in range 0..11, got ' + month);
    }
    return month >= exports.SUMMER_START_MONTH && month < exports.WINTER_START_MONTH;
};
exports.isSummerMonth = isSummerMonth;
/**
 * Get the Season in which `date` falls.
 */
const getSeason = (date = new Date()) => {
    const summer = (0, exports.isSummerMonth)(date.getMonth());
    let startingYear = date.getFullYear();
    if (!summer && date.getMonth() < exports.SUMMER_START_MONTH) {
        startingYear -= 1;
    }
    return {
        type: summer ? 'summer' : 'winter',
        startingYear,
    };
};
exports.getSeason = getSeason;
/**
 * Get an array of Seasons, starting with the season in which `startDate` falls.
 *
 * @param numSeasons Number of Seasons to include in the array.
 * @param startDate Date of the first Season in the array.
 */
const getUpcomingSeasons = (numSeasons, startDate = new Date()) => {
    const seasons = [(0, exports.getSeason)(startDate)];
    for (let i = 0; i < numSeasons - 1; ++i) {
        const previousSeason = seasons[i];
        seasons.push(previousSeason.type === 'summer'
            ? { type: 'winter', startingYear: previousSeason.startingYear }
            : { type: 'summer', startingYear: previousSeason.startingYear + 1 });
    }
    return seasons;
};
exports.getUpcomingSeasons = getUpcomingSeasons;
/**
 * Parse a Season from a string representation.
 *
 * @example parseSeason('Winter 2000') // { type: 'winter', startingYear: 2000 }
 */
const parseSeason = (seasonString) => {
    const [type, yearString] = seasonString.toLowerCase().split(' ');
    const startingYear = Number.parseInt(yearString !== null && yearString !== void 0 ? yearString : 'NaN', 10);
    if (!(0, exports.isSeasonType)(type) || Number.isNaN(startingYear)) {
        throw new SyntaxError(`Failed to parse seasonString: "${seasonString}"`);
    }
    return { type, startingYear };
};
exports.parseSeason = parseSeason;
/**
 * Get the date range for a given season in ISO 8601 format.
 *
 * @example getSeasonDates({ type: 'summer', startingYear: 2000 }) // [ '2000-05-01', '2000-10-30' ]
 */
const getSeasonDates = (season) => {
    const startMonth = season.type === 'summer' ? '05' : '11';
    const endYear = season.type === 'summer' ? season.startingYear : season.startingYear + 1;
    const endMonth = season.type === 'summer' ? '10' : '04';
    const endDay = season.type === 'summer' ? '31' : '30';
    return [
        `${season.startingYear}-${startMonth}-01`, `${endYear}-${endMonth}-${endDay}`,
    ];
};
exports.getSeasonDates = getSeasonDates;
/**
 * Check if the passed date range overlaps the passed Season.
 *
 * @param dateRange ISO 8601 dates
 *
 *
 * @example seasonOverlapsDateRange([ '2000-01-01', '2000-01-02' ], { startingYear: 1999, type: 'winter' }) // true
 */
const seasonOverlapsDateRange = (dateRange, season) => {
    const [startDateA, endDateA] = [...dateRange].sort();
    const [startDateB, endDateB] = (0, exports.getSeasonDates)(season);
    return startDateA <= endDateB && endDateA >= startDateB;
};
exports.seasonOverlapsDateRange = seasonOverlapsDateRange;
//# sourceMappingURL=season.js.map